/* globals $ */
window.goalNumber = false;
window.goalAmount = false;

//updates virtual buffer of older screenreader
function updateVirtualBuffer() {
	var form = $('body>form #virtualBufferForm');
	if(form.length) {
		(form.val() == '1') ? form.val('0') : form.val('1');
	} else {
		var html = '<form><input id="virtualBufferForm" type="hidden" value="1" /></form>';
		$('body').append(html);
	}
}

/*
 * Focus invalid formelement
 * @param string elementId Element ID
 */
function focusFormElement(formElementId, errorMsgId) {
	if ($('#' + errorMsgId + ' strike').length < 1) {
		$('#' + formElementId).focus();
	}
}
window.focusFormElement = focusFormElement;

var moveFocusObj;
(function($) {
	$.fn.moveFocus = function(settings) {
		try {
			var config = { 'updateBuffer': 'true', 'tabindex': '-1' };
			if (settings) $.extend(config, settings);

			var domObj = this.get(0);

			var focus_exceptions = { A:1,AREA:1,BUTTON:1,INPUT:1,OBJECT:1,SELECT:1,TEXTAREA:1 };
			if(
				(!focus_exceptions[domObj.nodeName] &&
				(domObj.getAttribute('tabIndex') == null || !domObj.getAttributeNode('tabIndex').specified))
			)
			{
				domObj.setAttribute('tabIndex',config.tabindex);
			}
			if (config.updateBuffer) {
				updateVirtualBuffer();
			}
		/*	if(document.all)dom_object.focus();*/
			moveFocusObj = domObj;
			setTimeout('$.fn.moveFocusNow()',180);
		}catch(e){}

		return this;
	};
	$.fn.moveFocusNow = function() {
		try {
			moveFocusObj.focus();
		}catch(e){}
	};
})($);